import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const FeaturedProductsSlider = ({ products }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow:4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <div className="featured-products-slider">

      <Slider {...settings}>
        {products.map((product) => (
          <div key={product.id} className="product-item">
            <div className="product-item-inner">
            <img 
              src={product.product_photo || 'https://www.bharatsteels.in/blog/wp-content/uploads/2021/10/steel.jpg'} 
              alt={product.product_name || 'Product Name'} 
              className="product-image"
            />
            <h3 className="product-title">{product.product_name || 'Product Name'}</h3>
            </div>
          </div>
        ))}
      </Slider>
   
    </div>
  );
};

export default FeaturedProductsSlider;
